/**
 * Writes framework-controlled markup at an explicitly reviewed HTML boundary.
 * Callers must not pass request, API, or user-provided content.
 */
export function setTrustedInnerHTML(target, trustedHtml) {
    target.innerHTML = trustedHtml; // ubs:ignore -- centralized sink accepts only framework-controlled markup; untrusted content must use safeInnerHTML
}
//# sourceMappingURL=trusted-html.js.map